export enum ClientPost {
  ELS = 'ecologistic',
  ELSTest = 'ecologistictest',
  Koder = 'koder',
  Kolporter = 'kolporter',
  Logistar = 'logistar',
  Totalpost = 'totalpost',
  TotalpostTest = 'totalposttest',
  MyBox = 'mybox',
  BoxPost = 'boxpost',
}
